import { useTranslation } from 'react-i18next';

import Button from '../../../../components/Button/Button';
import { BUTTON_VARIANT } from '../../../../constants/interfaces';
import { IRO_QUESTION_TYPES } from '../../../../constants/materialAssessment';
import MAIROQuestionRate from './MAIROQuestionRate';
import MAIROQuestionSelect from './MAIROQuestionSelect';
import MAIROQuestionSwitcher from './MAIROQuestionSwitcher';

import type { IMAIroQuestion } from '../interfaces/IMAIroQuestions';
import type { IMAIroRisksOrOpporttQuestionsProps } from '../interfaces/IMAIroRisksOrOpporttQuestionsProps';

import styles from '../scss/MAIROQuestion.module.scss';

function MAIRORisksOrOpportQuestions({
  questions,
  control,
  setValue,
  handleOpenFinishModal,
}: IMAIroRisksOrOpporttQuestionsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      {questions?.map((question: IMAIroQuestion, index: number) => (
        <>
          {question.questionType === IRO_QUESTION_TYPES.SWITCH && (
            <MAIROQuestionSwitcher
              key={question.id}
              question={question}
              control={control}
              setValue={setValue}
              questionIndex={index}
              currentValue={undefined}
            />
          )}
          {question.questionType === IRO_QUESTION_TYPES.SELECT && (
            <MAIROQuestionSelect
              key={question.id}
              question={question}
              control={control}
              setValue={setValue}
              questionIndex={index}
              currentValue={undefined}
            />
          )}
          {question.questionType === IRO_QUESTION_TYPES.RATE && (
            <MAIROQuestionRate
              key={question.id}
              question={question}
              setValue={setValue}
              questionIndex={index}
              control={control}
              currentValue={undefined}
            />
          )}
        </>
      ))}
      <div className={styles.footer}>
        <Button
          title={t('common.finish')}
          className={styles.nextStep}
          variant={BUTTON_VARIANT.primary}
          onClick={() => handleOpenFinishModal(true)}
        />
      </div>
    </div>
  );
}

export default MAIRORisksOrOpportQuestions;
